import { render, staticRenderFns } from "./GeneratePeriodsForm.vue?vue&type=template&id=6fd6d8c6&scoped=true&"
import script from "./GeneratePeriodsForm.vue?vue&type=script&lang=js&"
export * from "./GeneratePeriodsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd6d8c6",
  null
  
)

export default component.exports